import type { ProductDto, TodayDto } from '@exam-prep/contracts';
import { useQuery } from '@tanstack/react-query';
import { get } from './api';
import { hasPermission, type Me } from './auth';
import { pickProduct, productsWith, totalOpen, type SupportCounts } from './product';

/** The products list and the open review and support counts the sidebar shows as badges. */
export function useNavBadges(me: Me | null | undefined) {
  const bank = hasPermission(me, 'item.read');
  const support = me?.permissions.some((p) => p.permission === 'support.read') ?? false;

  // Same query keys as the Today and Products pages, so the badge shares their cache.
  const today = useQuery({
    queryKey: ['today'],
    queryFn: () => get<TodayDto>('/admin/today'),
    enabled: bank,
    refetchInterval: 30_000,
  });
  const products = useQuery({
    queryKey: ['products'],
    queryFn: () => get<ProductDto[]>('/admin/products'),
  });
  const supportProductId = support
    ? pickProduct(productsWith(me, products.data, 'support.read'), null)?.id
    : undefined;
  const supportCounts = useQuery({
    queryKey: ['support-counts', supportProductId],
    queryFn: () =>
      get<SupportCounts>(`/admin/products/${supportProductId ?? ''}/telegram/ticket-counts`),
    enabled: !!supportProductId,
    refetchInterval: 60_000,
  });
  return {
    products: products.data,
    reviewOpen: today.data?.review.open,
    supportOpen: totalOpen(supportCounts.data),
  };
}
